export const newsletterData = {
    header: '#BądźSkąpy - nie przegap okazji!',
    title: 'Zapisz się do newslettera Skąpiec.pl',
    list: ['Porównuj ceny', 'Sprawdzaj rankingi', 'Wybieraj najlepsze oferty'],
    // eslint-disable-next-line max-len
    text: 'Klikając przycisk „Zapisz się” wyrażasz zgodę na otrzymywanie na Twój adres e-mail podany powyżej informacji handlowej w postaci Newslettera [Skąpiec.pl], dostarczanej przez Ringier Axel Springer Polska sp. z o.o. z siedzibą w Warszawie („RASP”). Newsletter może zawierać informacje handlowe przesyłane przez RASP w imieniu własnym lub na zlecenie jej Zaufanych Partnerów.'
};
